const header = document.querySelector(".navpage-header");
const toggleClass = "is-sticky";
window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 150) {
        header.classList.add(toggleClass);
    } else {
        header.classList.remove(toggleClass);
    }
});




$(document).ready(function() {
    $("#bannerslider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        navText: ["<span><i class='fa fa-angle-right'></i></span>", "<span><i class='fa fa-angle-left'></i></span>"]
    });

    


    $("#client-success").owlCarousel({
        items: 2,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });





	

    $("#offerSlider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span></span>", "<span></span>"]



    });
	
	 $("#offerSlider1").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        animateIn: 'fadeIn', 
        animateOut: 'fadeOut',
       autoplayHoverPause: 'True',
  
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 0
            }
        },

        navText: ["<span></span>", "<span></span>"]



    });
	
	
	
	
	
	
 $("#team-slid1").owlCarousel({
        items: 3,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span></span>", "<span></span>"]



    });



	 $("#related-slid").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 2,
                nav: true
            },
            600: {
                items: 4,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 10
            }
        },

        navText: ["<span></span>", "<span></span>"]



    });






});

jQuery(window).scroll(function() {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 100) {
        jQuery('header').addClass('fixed-nav');
    } else {
        jQuery('header').removeClass('fixed-nav');
    }
});


